export var buildBotEngineHeaders = function (context, hasBody) {
    if (hasBody === void 0) { hasBody = false; }
    var headers = {
        "Authorization": "Bearer ".concat(requireValue(context.authToken, "AIGO_AUTH_TOKEN")),
        "x-client-id": requireValue(context.clientId, "AIGO_CLIENT_ID"),
        "x-bot-id": requireValue(context.botId, "AIGO_BOT_ID"),
        "x-session-id": requireValue(context.sessionId, "session_id"),
        "x-user-id": requireValue(context.userId, "user_id"),
    };
    if (hasBody) {
        headers["Content-Type"] = "application/json";
    }
    return headers;
};
export var createMessageRequest = function (text, messageOrderId, messageOptions) {
    if (messageOptions === void 0) { messageOptions = {}; }
    return ({
        message_text: text,
        message_order_id: messageOrderId,
        message_size: text.length,
        message_timestamp: new Date().toISOString(),
        message_options: messageOptions,
    });
};
var requireValue = function (value, name) {
    if (!value || value.trim().length === 0) {
        throw new Error("Missing required AIGO Bot Engine value: ".concat(name));
    }
    return value;
};
